export default __webpack_public_path__ + "static/media/step3.516f3e97.gif";